import { render, staticRenderFns } from "./modulo-calendario.vue?vue&type=template&id=56142f3a"
import script from "./modulo-calendario.vue?vue&type=script&lang=js"
export * from "./modulo-calendario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports